// New URL namespace bypasses old one-year immutable browser entries.
const base = '/api/map-tiles?v=2&url=';

const PLACEHOLDERS = ['{z}', '{x}', '{y}'];

const encodeTemplatePreservingPlaceholders = (template: string) => {
  let encoded = encodeURIComponent(template);
  PLACEHOLDERS.forEach((token) => {
    encoded = encoded.split(encodeURIComponent(token)).join(token);
  });
  return encoded;
};

export const cachedTileUrl = (url: string) => `${base}${encodeTemplatePreservingPlaceholders(url)}`;

export const MAP_TILE_URLS = {
  arcgisImagery: cachedTileUrl('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'),
  arcgisLabels: cachedTileUrl('https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}'),
};
